import type { FormErrors } from '@/features/clinic-profile/use-form-state'
import type { NetworkClinic, NetworkInput } from './api'

/**
 * O formulário do cadastro da rede, comum à criação e ao detalhe (docs/areas/administracao.md,
 * "Nova rede" e "Detalhe da rede"; RN-ADM-54). As mensagens são as da API, para o erro dizer o mesmo
 * nos dois lados; a composição sai sempre inteira (P-ADM-80).
 */

export interface NetworkFormState {
  name: string
  sharesPatients: boolean
  /** As clínicas da rede como ficam ao salvar: a composição inteira (RN-ADM-54). */
  clinics: NetworkClinic[]
}

export const EMPTY_NETWORK_FORM: NetworkFormState = { name: '', sharesPatients: false, clinics: [] }

export const NETWORK_FORM_KEYS = ['name'] as const satisfies readonly (keyof NetworkFormState)[]

export const MSG_NAME = 'Dê um nome à rede, como Franquia São Paulo.'
export const MSG_NAME_LENGTH = 'O nome da rede tem de 2 a 80 caracteres.'

/** As mesmas mensagens da API, para o erro dizer o mesmo nos dois lados. */
export function validateNetworkForm(values: NetworkFormState): FormErrors<NetworkFormState> {
  const name = values.name.trim()
  if (name === '') return { name: MSG_NAME }
  if (name.length < 2 || name.length > 80) return { name: MSG_NAME_LENGTH }
  return {}
}

/** O corpo que a API recebe: o conjunto completo de clínicas (RN-ADM-54). */
export function networkInput(values: NetworkFormState): NetworkInput {
  return {
    name: values.name.trim(),
    sharesPatients: values.sharesPatients,
    clinicIds: values.clinics.map((clinic) => clinic.id),
  }
}

/** O campo do formulário que corresponde a um caminho do 422 (`clinicIds.2` cai na composição). */
export function networkFieldKey(path: string): keyof NetworkFormState | undefined {
  if (path === 'name') return 'name'
  if (path === 'sharesPatients') return 'sharesPatients'
  if (path === 'clinicIds' || path.startsWith('clinicIds.')) return 'clinics'
  return undefined
}

/** O nome que a tela mostra: nome fantasia, ou a razão social. */
export function clinicLabel(clinic: Pick<NetworkClinic, 'legalName' | 'tradeName'>) {
  return clinic.tradeName ?? clinic.legalName
}
